const PRIVATE_ROUTE_PREFIXES = [
  '/admin',
  '/chat',
  '/dashboard',
  '/login'
]

export default defineNuxtRouteMiddleware((to) => {
  if (PRIVATE_ROUTE_PREFIXES.some(prefix => to.path === prefix || to.path.startsWith(`${prefix}/`))) {
    return navigateTo('/', { redirectCode: 302 })
  }
})
